module.exports = __webpack_public_path__ + "img/case-1-mobile.45315de.jpg";